<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs type="InertiaLink" :pages="meta.breadcrumbs" />
        </template>

        <div class="flex gap-4 flex-wrap" v-if="subjects.length > 0">
            <div v-if="filters.group_id">
                <div>
                    {{ $tc('messages.subject', 2) }}
                </div>
                <div class="flex flex-wrap gap-x-2">
                    <AppButton
                        element="InertiaLink"
                        :href="subject.url"
                        v-for="subject in subjects"
                        :key="subject.id"
                        class="flex gap-x-2"
                    >
                        {{ subject.text }}

                        <IconCircleCheckFilled
                            class="h-5 w-5 text-indigo-600"
                            v-if="filters.subject_id == subject.id"
                        />
                    </AppButton>
                </div>
            </div>
            <div v-if="filters.subject_id">
                <div>
                    {{ $tc('messages.sections', 1) }}
                </div>
                <div>
                    <label v-for="section in sections" :key="section.section">
                        <BadgePill :color="section.section === selectedSection ? 'indigo' : 'gray'">
                            {{ section.title }}
                            <input
                                type="radio"
                                name="section"
                                :id="section.section"
                                :value="section.section"
                                v-model="selectedSection"
                                class="sr-only"
                            />
                        </BadgePill>
                    </label>
                </div>
            </div>
        </div>
        <div v-else>
            <EmptyState picture>
                <template v-slot:picture />
            </EmptyState>
        </div>
        <template v-slot:pagination>
            <div v-if="filters.subject_id">
                <!--        Widgets section-->
                <DashboardTeacherWidgets :widgets="filteredWidgets" v-if="filteredWidgets.length > 0" />
                <EmptyState picture v-else>
                    <template v-slot:picture />
                </EmptyState>
            </div>
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import DashboardTeacherWidgets from '@/components/DashboardTeacherWidgets.vue';
import EmptyState from '@/components/EmptyState.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import AppButton from '@/components/AppButton.vue';
import BadgePill from '../../../../components/BadgePill.vue';

export default {
    components: {
        BadgePill,
        AppButton,
        IconCircleCheckFilled,
        SmartBreadcrumbs,
        PanelPage,
        EmptyState,
        DashboardTeacherWidgets,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'filters', 'subjects', 'sections', 'widgets'],
    data() {
        return {
            selectedSection: this.filters.section,
        };
    },
    computed: {
        filteredWidgets: function () {
            return this.widgets.filter((w) => w.section === this.selectedSection);
        },
    },
};
</script>
